let DIRECTION = null;

export const direction = function () {
    if (DIRECTION === null) {
        DIRECTION = getComputedStyle(document.body).direction;
    }

    return DIRECTION;
};

export const isRTL = function () {
    return direction() === 'rtl';
};

export const createUISlider = function (element, onUpdateCallback) {
    const min = $(element).data('min');
    const max = $(element).data('max');
    const from = $(element).data('from');
    const to = $(element).data('to');
    const slider = element.querySelector('.filter-price__slider');

    noUiSlider.create(slider, {
        start: [from, to],
        connect: true,
        direction: isRTL() ? 'rtl' : 'ltr',
        range: {
            'min': min,
            'max': max
        }
    });

    const titleValues = [
        $(element).find('.filter-price__min-value')[0],
        $(element).find('.filter-price__max-value')[0]
    ];

    slider.noUiSlider.on('update', function (values, handle) {
        titleValues[handle].innerHTML = values[handle];
    });
    slider.noUiSlider.on('end', function (values) {
        if (onUpdateCallback) {
            onUpdateCallback(values);
        }
    });
};